import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListChallengesRequest } from './list-challenges-request';
import type { IListChallengesResponse } from './list-challenges-response';
import { listChallengesResponseSchema } from './list-challenges-response';

// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: query parameter building
export async function listChallengesApi(
  params?: IListChallengesRequest,
): Promise<IValidatedResponse<IListChallengesResponse>> {
  const queryParams: Record<string, string> = {};
  if (params?.type) {
    queryParams.type = params.type;
  }
  if (params?.cefrLevel) {
    queryParams.cefrLevel = params.cefrLevel;
  }
  if (params?.language) {
    queryParams.language = params.language;
  }
  if (params?.partOfSpeech) {
    queryParams.partOfSpeech = params.partOfSpeech;
  }
  if (params?.query) {
    queryParams.query = params.query;
  }
  if (params?.cursor) {
    queryParams.cursor = params.cursor;
  }
  if (params?.triageStatus) {
    queryParams.triageStatus = params.triageStatus;
  }
  if (params?.published) {
    queryParams.published = params.published;
  }
  if (params?.translatedLang) {
    queryParams.translatedLang = params.translatedLang;
  }
  if (params?.collectionIds?.length) {
    queryParams.collectionIds = params.collectionIds.join(',');
  } else if (params?.collectionId !== undefined) {
    queryParams.collectionId = String(params.collectionId);
  }
  if (params?.source) {
    queryParams.source = params.source;
  }
  if (params?.onboarding) {
    queryParams.onboarding = 'true';
  }

  return getRequest<IListChallengesResponse>({
    path: '/sys/challenges',
    schema: listChallengesResponseSchema,
    options: { params: Object.keys(queryParams).length > 0 ? queryParams : undefined },
  });
}
